
export const ADVANCED_FILTER_TYPE = {
    FILTER: 0,
    LOGIC: 1
}